<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content">
			<div class="columns column6">
				<p>
					<font-awesome-icon icon="fa-regular fa-location-dot" size="1x" />
					<strong>{{ defaults[locale].website.hotelName }}</strong>
					<br />
					<span>{{ defaults[locale].website.street }} {{ defaults[locale].website.number }}</span>
					<br />
					<span>{{ defaults[locale].website.postalCode }} {{ defaults[locale].website.city }}</span>
					<br />
					<span>{{ defaults[locale].website.country }}</span>
					<br />
					<a :href="`tel:${$phoneRaw(defaults[locale].website.phone)}`">
						<span>T: {{ defaults[locale].website.phone }}</span>
					</a>
					<br />
					<a :href="`mailto:${defaults[locale].website.email}`">
						<span>E: {{ defaults[locale].website.email }}</span>
					</a>
				</p>
			</div>
		</main-content>
		<section class="main-content background-light">
			<div class="row contact-form-row">
				<div class="columns column6 contact-form-col">
					<h2>{{ $t('contactFormHeader') }}</h2>
					<contact-form name="contact" :form="form" />
				</div>

				<div class="columns column6 maps">
					<iframe
						id="maps"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3446.8503847164784!2d5.938633116956404!3d52.34700213342473!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c7c57dba243235%3A0x336b45b19dbf10aa!2sWitte%20Berken%20Natuurhotel!5e0!3m2!1snl!2snl!4v1678782631013!5m2!1snl!2snl"
						width="100%"
						height="450"
						style="border: 0"
						allowfullscreen=""
						loading="lazy"
					/>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const { data: form } = await useWebsiteFetch('contact', {
	query: { language: locale.value },
	key: `${locale.value}/contact`,
});
</script>

<style lang="scss" scoped>
.contact-form-row {
	background: #fff;
}

.contact-form-col {
	background: #fff;
	padding: 50px;
}

.contact-form {
	margin: 40px 0 0;

	input,
	textarea {
		width: 100%;
		max-width: 500px;
		padding: 20px;
		border: none;
		margin: 0 0 25px;
		box-shadow: 0 0 20px rgb(0 0 0 / 10%);
		font-family: $body-font-family;
	}

	textarea {
		min-height: 140px;
		max-width: 100%;
	}

	.button {
		width: auto;
		appearance: none;
		cursor: pointer;
		outline: none;
		border: none;
		padding: 10px 25px;
	}
}

.maps {
	background: #fff;
	padding: 20px;
}

#maps {
	min-height: 600px;
}

.checkbox-container {
	display: flex;
	flex-flow: nowrap row;
	justify-content: space-between;
	align-items: center;
	gap: 10px;
	margin: 0 0 25px;
}

.checkbox-container input {
	width: auto;
	margin: 0;
}
</style>
